<div #Pad__Wrapper class="flex items-center justify-center">
  <signature-pad
    #signature
    [options]="signaturePadOptions"
    style="border: dashed 1px var(--primary-color); border-radius: 6px"
    (drawEnd)="drawComplete()"
    (window:resize)="handleSignatureCanvasSize()"
  ></signature-pad>
</div>
<div class="my-8">
  <p-tag value="Importante"></p-tag> La firma debe ser igual a la que aparece en
  el documento identificativo aportado. La firma digital de este contrato tendrá
  validez legal.
</div>
@if(showActions()) {
  <div class="flex mt-auto justify-end">
    <p-button
      (click)="clearPad()"
      class="mr-4"
      severity="danger"
      size="small"
      [outlined]="true"
      >Limpiar y repetir</p-button
    >
    <p-button (click)="savePad()" size="small">Confirmar firma</p-button>
  </div>
}

